import axios from 'axios';

export default axios.create({
    baseURL:'https://movie-review-app-9gvb.onrender.com'
});